<div class="nb-select" [ngClass]="{ 'full-width': innerOptions.fullWidth }">
  <nb-dropdown [options]="innerOptions" [data]="data" [ngModel]="value" (change)="setModel($event)">
    <ng-template #triggerTemplate>
      <button type="button" class="btn btn-default btn-block d-flex justify-content-between align-items-center">
        <span>{{ value ? value[innerOptions.labelField] : innerOptions.placeholder }}</span>
        <i class="fas fa-angle-down"></i>
      </button>
    </ng-template>
  </nb-dropdown>
</div>
